import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowUpFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.158 17c-1.03 0-1.545-1.224-.817-1.94l6.842-6.727a1.17 1.17 0 0 1 1.634 0l6.842 6.727c.728.716.213 1.94-.817 1.94H5.158Z", fill: color }));
};
export default factorySvgIcon(SvgArrowUpFilled);
//# sourceMappingURL=SvgArrowUpFilled.js.map